import React from 'react';

import { useResponsive } from './useResponsive';

/**
 * Injects width-based responsive flags into class components so mobile-only
 * UI updates on DevTools resize without a full page refresh.
 * Prefer this over `react-device-detect` (UA-frozen).
 *
 * Props added:
 * - shouldUseMobileLayout / shouldUseDesktopLayout / shouldCollapseSider
 * - screenWidth
 * - isMobile — phone band (< 768)
 * - isMobileOnly — alias of shouldUseMobileLayout (< 1180) for drop-ins
 */
function withResponsive(WrappedComponent) {
  const WithResponsive = (props) => {
    const {
      shouldUseMobileLayout,
      shouldUseDesktopLayout,
      shouldCollapseSider,
      screenWidth,
      isMobile,
      isMobileOnly,
    } = useResponsive();

    return (
      <WrappedComponent
        {...props}
        shouldUseMobileLayout={shouldUseMobileLayout}
        shouldUseDesktopLayout={shouldUseDesktopLayout}
        shouldCollapseSider={shouldCollapseSider}
        screenWidth={screenWidth}
        isMobile={isMobile}
        isMobileOnly={isMobileOnly}
      />
    );
  };

  const name = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithResponsive.displayName = `withResponsive(${name})`;

  return WithResponsive;
}

export default withResponsive;
